import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enForms from './locales/en/forms.json';
import enPatients from './locales/en/patients.json';
import enDashboard from './locales/en/dashboard.json';
import enAuth from './locales/en/auth.json';
import enSidebar from './locales/en/sidebar.json';
import enTeam from './locales/en/team.json';
import enPatientsPage from './locales/en/patientsPage.json';
import enFilesPage from './locales/en/filesPage.json';
import enPermissionGroups from './locales/en/permissionGroups.json';
import enInviteDoctor from './locales/en/inviteDoctor.json';
import enAddPatient from './locales/en/addPatient.json';
import enDoctorProfile from './locales/en/doctorProfile.json';
import enFormulas from './locales/en/formulas.json';
import enCalendar from './locales/en/calendar.json';
import enFaq from './locales/en/faq.json';
import enPublicForm from './locales/en/publicForm.json';
import enPatientControllerErrors from './locales/en/ErrorMessages/patientControllerErrors.json';
import enTenantDashboard from './locales/en/TenantPanel/dashboard.json';
import enMarketing from './locales/en/Marketing/marketing.json';
import enAbout from './locales/en/Marketing/about.json';
import enTopbar from './locales/en/Marketing/topbar.json';
import enContact from './locales/en/Marketing/contact.json';
import enRegister from './locales/en/Marketing/register.json';
import enLogin from './locales/en/Marketing/login.json';
import enFooter from './locales/en/Marketing/footer.json';
import enStats from './locales/en/stats.json';
import enApiErrors from './locales/en/apiErrors.json';
import enSubscription from './locales/en/subscription.json';
import enSeo from './locales/en/seo.json';

import trCommon from './locales/tr/common.json';
import trForms from './locales/tr/forms.json';
import trPatients from './locales/tr/patients.json';
import trDashboard from './locales/tr/dashboard.json';
import trAuth from './locales/tr/auth.json';
import trSidebar from './locales/tr/sidebar.json';
import trTeam from './locales/tr/team.json';
import trPatientsPage from './locales/tr/patientsPage.json';
import trFilesPage from './locales/tr/filesPage.json';
import trPermissionGroups from './locales/tr/permissionGroups.json';
import trInviteDoctor from './locales/tr/inviteDoctor.json';
import trAddPatient from './locales/tr/addPatient.json';
import trDoctorProfile from './locales/tr/doctorProfile.json';
import trFormulas from './locales/tr/formulas.json';
import trCalendar from './locales/tr/calendar.json';
import trFaq from './locales/tr/faq.json';
import trPublicForm from './locales/tr/publicForm.json';
import trPatientControllerErrors from './locales/tr/errorMessages/patientControllerErrors.json';
import trTenantDashboard from './locales/tr/TenantPanel/dashboard.json';
import trMarketing from './locales/tr/Marketing/marketing.json';
import trAbout from './locales/tr/Marketing/about.json';
import trTopbar from './locales/tr/Marketing/topbar.json';
import trContact from './locales/tr/Marketing/contact.json';
import trRegister from './locales/tr/Marketing/register.json';
import trLogin from './locales/tr/Marketing/login.json';
import trFooter from './locales/tr/Marketing/footer.json';
import trStats from './locales/tr/stats.json';
import trApiErrors from './locales/tr/apiErrors.json';
import trSubscription from './locales/tr/subscription.json';
import trSeo from './locales/tr/seo.json';

import frCommon from './locales/fr/common.json';
import frForms from './locales/fr/forms.json';
import frPatients from './locales/fr/patients.json';
import frDashboard from './locales/fr/dashboard.json';
import frAuth from './locales/fr/auth.json';
import frSidebar from './locales/fr/sidebar.json';
import frTeam from './locales/fr/team.json';
import frPatientsPage from './locales/fr/patientsPage.json';
import frFilesPage from './locales/fr/filesPage.json';
import frPermissionGroups from './locales/fr/permissionGroups.json';
import frInviteDoctor from './locales/fr/inviteDoctor.json';
import frAddPatient from './locales/fr/addPatient.json';
import frDoctorProfile from './locales/fr/doctorProfile.json';
import frFormulas from './locales/fr/formulas.json';
import frCalendar from './locales/fr/calendar.json';
import frFaq from './locales/fr/faq.json';
import frPublicForm from './locales/fr/publicForm.json';
import frPatientControllerErrors from './locales/fr/ErrorMessages/patientControllerErrors.json';
import frTenantDashboard from './locales/fr/TenantPanel/dashboard.json';
import frMarketing from './locales/fr/Marketing/marketing.json';
import frAbout from './locales/fr/Marketing/about.json';
import frTopbar from './locales/fr/Marketing/topbar.json';
import frContact from './locales/fr/Marketing/contact.json';
import frRegister from './locales/fr/Marketing/register.json';
import frLogin from './locales/fr/Marketing/login.json';
import frFooter from './locales/fr/Marketing/footer.json';
import frStats from './locales/fr/stats.json';
import frApiErrors from './locales/fr/apiErrors.json';
import frSubscription from './locales/fr/subscription.json';
import frSeo from './locales/fr/seo.json';

const resources = {
  en: {
    common: enCommon,
    forms: enForms,
    patients: enPatients,
    dashboard: enDashboard,
    auth: enAuth,
    sidebar: enSidebar,
    team: enTeam,
    patientsPage: enPatientsPage,
    filesPage: enFilesPage,
    permissionGroups: enPermissionGroups,
    inviteDoctor: enInviteDoctor,
    addPatient: enAddPatient,
    doctorProfile: enDoctorProfile,
    formulas: enFormulas,
    calendar: enCalendar,
    faq: enFaq,
    publicForm: enPublicForm,
    errors: enPatientControllerErrors,
    tenantDashboard: enTenantDashboard,
    marketing: enMarketing,
    about: enAbout,
    topbar: enTopbar,
    contact: enContact,
    register: enRegister,
    login: enLogin,
    footer: enFooter,
    stats: enStats,
    apiErrors: enApiErrors,
    subscription: enSubscription,
    seo: enSeo,
  },
  tr: {
    common: trCommon,
    forms: trForms,
    patients: trPatients,
    dashboard: trDashboard,
    auth: trAuth,
    sidebar: trSidebar,
    team: trTeam,
    patientsPage: trPatientsPage,
    filesPage: trFilesPage,
    permissionGroups: trPermissionGroups,
    inviteDoctor: trInviteDoctor,
    addPatient: trAddPatient,
    doctorProfile: trDoctorProfile,
    formulas: trFormulas,
    calendar: trCalendar,
    faq: trFaq,
    publicForm: trPublicForm,
    errors: trPatientControllerErrors,
    tenantDashboard: trTenantDashboard,
    marketing: trMarketing,
    about: trAbout,
    topbar: trTopbar,
    contact: trContact,
    register: trRegister,
    login: trLogin,
    footer: trFooter,
    stats: trStats,
    apiErrors: trApiErrors,
    subscription: trSubscription,
    seo: trSeo,
  },
  fr: {
    common: frCommon,
    forms: frForms,
    patients: frPatients,
    dashboard: frDashboard,
    auth: frAuth,
    sidebar: frSidebar,
    team: frTeam,
    patientsPage: frPatientsPage,
    filesPage: frFilesPage,
    permissionGroups: frPermissionGroups,
    inviteDoctor: frInviteDoctor,
    addPatient: frAddPatient,
    doctorProfile: frDoctorProfile,
    formulas: frFormulas,
    calendar: frCalendar,
    faq: frFaq,
    publicForm: frPublicForm,
    errors: frPatientControllerErrors,
    tenantDashboard: frTenantDashboard,
    marketing: frMarketing,
    about: frAbout,
    topbar: frTopbar,
    contact: frContact,
    register: frRegister,
    login: frLogin,
    footer: frFooter,
    stats: frStats,
    apiErrors: frApiErrors,
    subscription: frSubscription,
    seo: frSeo,
  },
};

// Function to convert detected language to supported language
const convertDetectedLanguage = (lng) => {
  if (!lng) return 'en';
  
  // Get the base language code (e.g., 'tr-TR' -> 'tr', 'en-US' -> 'en')
  const baseLang = lng.split('-')[0].toLowerCase();
  
  // Supported languages
  const supportedLanguages = ['tr', 'en', 'fr'];
  
  // If the base language is supported, return it
  if (supportedLanguages.includes(baseLang)) {
    return baseLang;
  }
  
  // Otherwise, return English as default
  return 'en';
};

i18n
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language
    supportedLngs: ['tr', 'en', 'fr'], // Supported languages
    defaultNS: 'common', // Default namespace
    ns: ['common', 'forms', 'patients', 'dashboard', 'auth', 'sidebar', 'team', 'patientsPage', 'filesPage', 'permissionGroups', 'inviteDoctor', 'addPatient', 'doctorProfile', 'formulas', 'calendar', 'faq', 'publicForm', 'errors', 'tenantDashboard', 'marketing', 'about', 'topbar', 'contact', 'register', 'login', 'footer', 'stats', 'apiErrors', 'subscription', 'seo'], // Available namespaces
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator'],
      // Keys to lookup language from
      lookupLocalStorage: 'i18nextLng',
      // Cache user language preference
      caches: ['localStorage'],
    },
  });

// After initialization, convert detected language to supported language
const detectedLang = i18n.language || navigator.language || 'en';
const convertedLang = convertDetectedLanguage(detectedLang);
if (i18n.language !== convertedLang) {
  i18n.changeLanguage(convertedLang);
}

export default i18n;
